import React, { useState } from 'react';

const PortfolioForm = ({ data, setData }) => {
  const [brokenIcons, setBrokenIcons] = useState(new Set());

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value });
  };


  const addProject = () => {
    setData({
      ...data,
      projects: [...data.projects, { title: '', description: '', link: '', color: '#ff007f' }],
    });
  };

  return (
    <form>
      <input
        className="form-control mb-3"
        placeholder="Your Name"
        value={data.name}
        onChange={(e) => handleChange('name', e.target.value)}
      />

      <textarea
        className="form-control mb-2"
        placeholder="Short Bio"
        maxLength="300"
        value={data.bio}
        onChange={(e) => handleChange('bio', e.target.value)}
      />

      <h5 className="mt-3">Upload Profile Picture</h5>
      <input
        type="file"
        accept="image/*"
        className="form-control mb-3"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
              setData({ ...data, profileImage: reader.result });
            };
            reader.readAsDataURL(file);
          }
        }}
      />
      <div className="d-flex align-items-center mb-3">
        <input
          type="color"
          className="form-control form-control-color me-2"
          value={data.imageBorderColor}
          onChange={(e) => handleChange('imageBorderColor', e.target.value)}
        />
        <input
          type="text"
          className="form-control text-light bg-dark border-0 me-2"
          value={data.imageBorderColor}
          onChange={(e) => handleChange('imageBorderColor', e.target.value)}
          style={{ maxWidth: '120px' }}
        />
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => navigator.clipboard.writeText(data.imageBorderColor)}
          type="button"
        >
          Copy
        </button>
      </div>

      <h5 className="mt-3">Skills</h5>
<input
  className="form-control mb-2"
  placeholder="Type a skill and press Enter"
  value={data.skillInput}
  onChange={e => setData({ ...data, skillInput: e.target.value })}
  onKeyDown={e => {
    if (e.key === 'Enter' && data.skillInput.trim()) {
      setData({
        ...data,
        skills: [...data.skills, data.skillInput.trim()],
        skillInput: ''
      });
      e.preventDefault();
    }
  }}
/>

<div className="mb-3 d-flex flex-wrap">
  {data.skills.map((skill, i) => {
    const skillMap = {
  'c++': 'cplusplus',
  'c#': 'csharp',
  'f#': 'fsharp',
  'node.js': 'nodejs',
};

const input = skill.toLowerCase().trim();
const normalized = skillMap[input] || input.replace(/\+/g, 'plus').replace(/\s/g, '');
const iconUrl = `https://skillicons.dev/icons?i=${normalized}`;
const isBroken = brokenIcons.has(skill) || input === 'c++' || input === 'c#';


    return (
      <div
        key={i}
        className="d-flex align-items-center me-3 mb-2 bg-dark px-2 py-1 rounded"
        style={{ border: '1px solid #444', color: '#fff' }}
      >
        {!isBroken ? (
          <img
            src={iconUrl}
            alt={skill}
            style={{ height: '24px', marginRight: '6px' }}
            onError={() => {
              setBrokenIcons(prev => new Set(prev).add(skill));
            }}
          />
        ) : (
          <span style={{ marginRight: '6px', color: '#fff' }}>{skill}</span>
        )}

        <button
          type="button"
          className="btn-close btn-close-white btn-sm"
          aria-label="Remove"
          onClick={() => {
            const updatedSkills = data.skills.filter((_, index) => index !== i);
            setData({ ...data, skills: updatedSkills });

            setBrokenIcons(prev => {
              const copy = new Set(prev);
              copy.delete(skill);
              return copy;
            });
          }}
          style={{ fontSize: '0.6rem' }}
        ></button>
      </div>
    );
  })}
</div>



      <h5 className="mt-3">Projects</h5>
      {data.projects.map((project, index) => (
  <div key={index} className="mb-3 p-3 border rounded bg-dark text-white">
   <div className="mb-2">
  <label>Title:</label>
  <input
    type="text"
    className="form-control"
    value={project.title}
    onChange={(e) => {
      setData(prevData => {
        const updatedProjects = [...prevData.projects];
        updatedProjects[index].title = e.target.value;
        return { ...prevData, projects: updatedProjects };
      });
    }}
  />
</div>

<div className="mb-2">
  <label>Description:</label>
  <textarea
    className="form-control"
    value={project.description}
    onChange={(e) => {
      setData(prevData => {
        const updatedProjects = [...prevData.projects];
        updatedProjects[index].description = e.target.value;
        return { ...prevData, projects: updatedProjects };
      });
    }}
  />
</div>

    <div className="mb-2">
      <label>Link:</label>
      <input
        type="url"
        className="form-control"
        value={project.link}
        onChange={(e) => {
          const updatedProjects = [...data.projects];
          updatedProjects[index].link = e.target.value;
          setData({ ...data, projects: updatedProjects });
        }}
      />
    </div>
    <div className="mb-2">
      <label>Color:</label>
      <input
        type="color"
        className="form-control form-control-color"
        value={project.color}
        onChange={(e) => {
          const updatedProjects = [...data.projects];
          updatedProjects[index].color = e.target.value;
          setData({ ...data, projects: updatedProjects });
        }}
      />
    </div>
     {/* Manual HEX input */}
    <input
      type="text"
      className="form-control me-2"
      value={project.color}
      onChange={(e) => {
        const updatedProjects = [...data.projects];
        updatedProjects[index].color = e.target.value;
        setData({ ...data, projects: updatedProjects });
      }}
      style={{ maxWidth: '120px' }}
    />

    {/* 🚨 REMOVE Button */}
    <div className="text-end">
    <button
  className="btn btn-sm btn-outline-danger"
  onClick={(e) => {
    e.preventDefault(); // prevent form submission
    setData(prevData => ({
      ...prevData,
      projects: prevData.projects.filter((_, i) => i !== index)
    }));
  }}
>
  Remove
</button>

    </div>
  </div>
))}


      <button
        type="button"
        className="btn btn-outline-info mt-3"
        onClick={addProject}
      >
        Add Project
      </button>

      <input
        className="form-control mt-4"
        placeholder="Contact Info"
        value={data.contact}
        onChange={(e) => handleChange('contact', e.target.value)}
      />
    </form>
  );
};

export default PortfolioForm;
